<template>
    <div class="app-title">
        <div>
            <h1>{{ name }}</h1>
            <p>Wanon Niwat Hospital [APACHE II APP WNH]</p>
        </div>
        <ul class="app-breadcrumb breadcrumb">
          <li class="breadcrumb-item"><i class="bi bi-house-door fs-7"></i></li>
          <li class="breadcrumb-item">
          <router-link to="/">หน้าหลัก</router-link>
          </li>
        </ul>
    </div>
</template>

<script>
export default {
    name: 'AppTitle',
    props: {
        name: {
            type: String,
            required: true,
        },
    },
}
</script>

<style scoped></style>